<script setup lang="ts">
import AppHeader from '@/components/layout/header/AppHeader.vue'
import AppSidebar from '@/components/layout/sidebar/AppSidebar.vue'
</script>

<template>
  <div class="flex h-screen min-h-screen flex-row overflow-hidden bg-background-default">
    <AppSidebar />

    <div class="flex min-w-0 flex-1 flex-col">
      <AppHeader />

      <main class="min-w-0 flex-1 overflow-auto p-3xl">
        <slot>
          <RouterView />
        </slot>
      </main>
    </div>
  </div>
</template>
